<template>
  <a-drawer
    :open="showForm"
    class="draw-kima-home"
    root-class-name="kima-drawer-root"
    :title="title"
    :placement="placement"
    @close="afterOpenChange"
  >
    <div class="">
      <slot name="content"></slot>
    </div>
  </a-drawer>
</template>
<script lang="ts" setup>
const emits = defineEmits(["closePopup", "submitPopup"]);
interface props {
  showForm: any;
  placement: any;
  title: any;
}
const propsData = withDefaults(defineProps<props>(), {
  showForm: false,
  placement: "right",
  title: "",
});

const afterOpenChange = (_bool: boolean) => {
  emits("closePopup", false);
};
</script>
<style lang="css" scoped>
.draw-kima-home {
  color: var(--text-white);
}

:global(.kima-drawer-root .ant-drawer-content-wrapper) {
  width: 360px !important;
  max-width: 90vw !important;
}

@media (max-width: 420px) {
  :global(.kima-drawer-root .ant-drawer-content-wrapper) {
    width: 320px !important;
  }
}

:global(.kima-drawer-root .ant-drawer-content) {
  background: var(--primary-dark) !important;
  color: var(--text-white) !important;
}

:global(.kima-drawer-root .ant-drawer-header) {
  background: var(--primary-dark) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
  padding: 14px 16px !important;
}

:global(.kima-drawer-root .ant-drawer-title) {
  color: var(--default-header-color) !important;
  font-weight: 700;
  letter-spacing: 0.3px;
}

:global(.kima-drawer-root .ant-drawer-close) {
  color: rgba(255, 255, 255, 0.9) !important;
}

:global(.kima-drawer-root .ant-drawer-close:hover) {
  color: var(--default-header-color) !important;
}

:global(.kima-drawer-root .ant-drawer-body) {
  padding: 12px 14px 20px !important;
}

:global(.kima-drawer-root .ant-drawer-body button) {
  color: inherit;
}

:global(.kima-drawer-root .ant-drawer-mask) {
  background: rgba(0, 0, 0, 0.55) !important;
}
</style>